// extracted by mini-css-extract-plugin
export var compactFilters = "_e4-4";
export var detailImage = "_e4-1";
export var dropdownContainer = "_e4-2";
export var imageContainer = "_e4-0";
export var selectedCard = "_e4-3";